import React from 'react'
import classNames from 'classnames'
import { Text } from 'components/base'

export default function Header() {
  return (
    <div
      className={classNames(
        'activity-header',
        'center-text',
        'background-shade-100 border-bottom-small border-shade-45 padding-horizontal-large padding-vertical-normal'
      )}
      style={{ height: 64 }}
    >
      <Text.Subtitle>Activity</Text.Subtitle>
      <div className="font-family-system margin-bottom-smaller font-size-normal font-weight-medium shade-30">
        What your team is working on
      </div>
    </div>
  )
}
